<template>
<v-alert
type="success"
dismissible
>{{ text }}</v-alert>
</template>

<script>
export default {
  name: "Alert",
  props: {
    text: {
      type: String,
      default: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi, ratione debitis quis est labore voluptatibus! Eaque cupiditate minima, at placeat totam, magni doloremque veniam neque porro libero rerum unde voluptatem!",
      required: true
    },
    type: {
      type: String,
      default: "success"
    }
  }
};
</script>